import * as types from '@/modules/Clients/store/mutation-types'
import clientsApi from '@/modules/Clients/api/'

export const defaultModuleName = 'clients'
export default {
  namespaced: true,
  state: {
    isLoading: false,
    organizationClients: [],
    organizationCurrentClient: {},
    allClients: [],
    totalAmount:0,

  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    organizationClients (state) {
      return state.organizationClients
    },

    organizationCurrentClient (state) {
      return state.organizationCurrentClient
    },
    allClients (state) {
      return state.allClients
    },
    totalAmount(state){
      return state.totalAmount
    },


  },
  mutations: {
    [types.IS_LOADING]: (state, status) => {
      return state.isLoading = status
    },
    [types.UPDATE_ORGANIZATION_CLIENTS]: (state, payload) => {
      return state.organizationClients = payload
    },
    [types.UPDATE_ORGANIZATION_CURRENT_CLIENT]: (state, payload) => {
      return state.organizationCurrentClient = payload
    },
    [types.UPDATE_CLIENTS_LIST]: (state, payload) => {
      return state.allClients = payload
    },
    [types.UPDATE_TOTAL_AMOUNT]: (state, payload) => {
      return state.totalAmount = payload
    },

  },
  actions: {
    async getClients ({commit}, payload) {

      commit(types.IS_LOADING, true)
      try {
        const resp = await clientsApi.getClients(payload)
        commit(types.UPDATE_CLIENTS_LIST, resp.data)
        commit(types.UPDATE_TOTAL_AMOUNT, resp.headers['x-total-count'])
      } catch (e) {
        this.$message.error('Ошибка при получении данных о клиентах')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getOrganizationClients ({commit}, payload) {
      commit(types.IS_LOADING, true)
      let {org_id, params} = payload
      try {
        let resp = await clientsApi.getOrganizationClients(
          org_id, params)
        commit(types.UPDATE_ORGANIZATION_CLIENTS, resp.data)
        commit(types.UPDATE_TOTAL_AMOUNT, resp.headers['x-total-count'])
      } catch (e) {
        this.$message.error('Ошибка при получении данных о клиентах')
      } finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getClient ({commit}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {client_id} = payload
        let resp = await clientsApi.getClient(client_id)
        commit(types.UPDATE_ORGANIZATION_CLIENTS, resp.data)
      } catch (e) {
        this.$message.error('Ошибка при получении данных о клиенте')
      }
      finally {
        commit(types.IS_LOADING, false)
      }
    },
    getOrganizationClientByName({state}, payload){
     let founded = state.organizationClients.find(item=> {
       return  item.name === payload
     })
      return founded
    },

    async postOrganizationClient({}, payload){
      let { org_id, params} = payload
      await clientsApi.postOrganizationClient(org_id, params)
    },

    async patchClient({}, payload){
      let { update_id, params} = payload
      return  clientsApi.patchClient(update_id, params)
    },

    async deleteClient({}, item_id){
      return  await clientsApi.deleteClient(item_id)
    }
  }
}
